import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
  MAX_PAGE_HEIGHT,
  PAGE_CONTAINER_HEADER_HEIGHT,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  bugReportWrapper: {
    height: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${PAGE_CONTAINER_HEADER_HEIGHT})`,
    maxHeight: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${PAGE_CONTAINER_HEADER_HEIGHT})`,

    [theme.breakpoints.down('md')]: {
      height: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT})`,
      maxHeight: `calc(${MAX_PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT})`,
    },
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },

  bugReportMessagesContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  newMessageWrapper: {},
  newMessageContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),

    '& button': {
      marginBottom: theme.spacing(1),
    },
  },
  uploadedFilesWrapper: {
    display: 'flex',
    overflowY: 'auto',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));
